import React, { Component } from "react";
import { UserContext } from "../../Context";
import SearchMap from "../../components/SearchMap/SearchMap";

import "./home.css";
export default class Home extends Component {
  render() {
    // console.log(this.props);
    return (
      <UserContext.Consumer>
        {userContext => {
          return (
            <div className="home">
              <SearchMap {...this.props} addFlag={userContext.addFlag} />
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/Home.js